import React, { useEffect, useState } from 'react';
import { objectOf, string, any, bool } from 'prop-types';
import get from 'lodash/get';
import { connect } from 'react-redux';
// import MailmodoNewsLetter from '../../molecules/newsletter/mailmodo-news-letter';
import SubscriptionComboBox from '../subscription-combo-box';
// import GetYourDailyBrief from '../../molecules/get-your-dailly-brief';
import {
  getPrimarySection,
  getSourceDisplayName,
  // getThinmintId
} from '../../../helpers/story-helpers';
import { trackUserInteraction } from '../../../helpers/datalayer-utils';
// import { getSectionSentence } from './utils';
import { syndicatedSource } from '../../../helpers/utils';
import AdWithPlaceholder from '../../molecules/ad-with-placeholder';
import AboutAuthor from '../authors/aboutAuthor';
import { WithLazy } from '@quintype/components';

import './footer.module.css';

const SyndicatedSource = ({ story }) => {
  const author = get(story, 'author-name');
  if (author === 'PTI') return null;

  const syndicatedFrom = get(story, ['metadata', 'story-attributes', 'syndicatedfrom', '0']);
  return <div styleName="syndicated-source">{getSourceDisplayName(syndicatedFrom)}</div>;
};

SyndicatedSource.propTypes = {
  story: objectOf(any).isRequired,
};

const Footer = (props) => {
  useEffect(() => {
    var cX = window.cX || {};
    cX.callQueue = cX.callQueue || [];
    cX.CCE = cX.CCE || {};
    cX.CCE.callQueue = cX.CCE.callQueue || [];
    cX.CCE.callQueue.push([
      'run',
      {
        // widgetId: 'bf408317f0c33e3364ff451f5103055d380fba1a',
        targetElementId: 'recomended-for-you-piano',
      },
    ]);
  }, []);

  const authorDetails = props.story.authors ?? [];

  const datalayerFields = {
    category: 'article page',
    action: 'NA',
    label: props.story.headline,
    event: 'event articlepage',
    cd22: 'link',
    cd23: 'NA', // element location
    cd24: 'NA', // element id
    cd26: syndicatedSource(props.story),
    cd31: props.story['story-template'] || 'text',
    cd35: 'NA', // recommendation engine
    cd34: 'NA', // source of the user
  };

  function checkBio(author) {
    return author.bio;
  }
  const isLiveBlog = get(props, ['story', 'story-template']) === 'live-blog';

  return (
    <React.Fragment>
      {props.story['story-template'] === 'news-elsewhere' && (
        <a href={props.story.metadata['reference-url']} styleName="read-more">
          Read More
        </a>
      )}
      <SectionLink
        section={getPrimarySection(props.story.sections)}
        storyHeadline={props.story.headline}
        isGeoBlock={props.isGeoBlock}
        isLiveBlog={isLiveBlog}
        isPremiumTemplate={props?.isPremiumTemplate}
        isSubscriber={props.isSubscriber}
      />

      <WithLazy>
        {() => (
          <>
            {authorDetails && authorDetails.some(checkBio) && (
              <h1 styleName="about-the-author">WRITTEN BY</h1>
            )}
            {authorDetails &&
              authorDetails.map((author, i) => {
                return <AboutAuthor authorDetails={author} key={i} />;
              })}
          </>
        )}
      </WithLazy>

      <WithLazy>
        {() => (
          <SubscriptionComboBox
            source="footer-Story Page"
            variant="horizontal"
            datalayerFields={datalayerFields}
          />
        )}
      </WithLazy>
      {/* <GetYourDailyBrief
        variant="horizontal"
        source="SB-Story Page"
        datalayerFields={datalayerFields}
      /> */}
      {/* <div id="bq-piano-test-story-page-newsletter" styleName="bq-piano-story-page-newsletter" /> */}
      {/* <div styleName="mailmodo-wrapper">
        <div className="desktop-only">
          <MailmodoNewsLetter
            heading="Get market moving news, top news & compelling perspectives"
            footerText1="No Spam. Just great journalism in your inbox"
            footerText2="View All Newsletters"
            page="story"
          />
        </div>
      </div> */}
      {/* <div id="cx_bf408317f0c33e3364ff451f5103055d380fba1a" /> */}
      <div
        className="content-center ad-bottom-margin mobile-only"
        styleName="belowrecommendedadunit"
      >
        {/* <AdWithPlaceholder adtype="BelowRecommendedWidgetmob" height="100px" /> */}
      </div>
    </React.Fragment>
  );
};

// class Footer extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       renderWruStories: false
//     };
//     this.showRelatedStories = this.showRelatedStories.bind(this);
//     this.sendEventsToGA = this.sendEventsToGA.bind(this);
//     this.showWruWidget = this.showWruWidget.bind(this);
//   }

//   componentDidMount() {
//     // this.setState({ renderWruStories: true }, this.showWruWidget);
//     var cX = window.cX || {};
//     cX.callQueue = cX.callQueue || [];
//     cX.CCE = cX.CCE || {};
//     cX.CCE.callQueue = cX.CCE.callQueue || [];
//     cX.CCE.callQueue.push([
//       'run',
//       {
//         widgetId: 'bf408317f0c33e3364ff451f5103055d380fba1a',
//         targetElementId: 'cx_bf408317f0c33e3364ff451f5103055d380fba1a'
//       }
//     ]);
//   }

//   sendEventsToGA(recommendationEngine) {
//     const datalayerFields = {
//       category: 'article page',
//       action: 'recommendationEngine',
//       event: 'event storyRecommendationWidget',
//       storyRecommendationWidget: recommendationEngine
//     };
//     trackUserInteraction(datalayerFields);
//   }

//   showWruWidget() {
//     const thinmintId = getThinmintId();
//     recommendationsWidget(
//       {
//         recommendation: 'article',
//         heading: 'Recommended for you',
//         userId: thinmintId,
//         merchantId: '130916',
//         articleId: this.props.story.id
//       },
//       'wru_recommendations--horizontal',
//       'horizontal'
//     );
//     this.sendEventsToGA('wru');
//   }

//   showRelatedStories() {
//     const { renderWruStories } = this.state;
//     if (renderWruStories) {
//       return <div styleName="wru" className="wru_recommendations--horizontal" />;
//     }
//     return null;
//   }

//   render() {
//     const datalayerFields = {
//       category: 'article page',
//       action: 'NA',
//       label: this.props.story.headline,
//       event: 'event articlepage',
//       cd22: 'link',
//       cd23: 'NA', // element location
//       cd24: 'NA', // element id
//       cd26: syndicatedSource(this.props.story),
//       cd31: this.props.story['story-template'] || 'text',
//       cd35: 'NA', // recommendation engine
//       cd34: 'NA' // source of the user
//     };

//     return (
//       <React.Fragment>
//         {/* <SyndicatedSource story={this.props.story} /> */}
//         {this.props.story['story-template'] === 'news-elsewhere' && (
//           <a href={this.props.story.metadata['reference-url']} styleName="read-more">
//             Read More
//           </a>
//         )}

//         <SectionLink
//           section={getPrimarySection(this.props.story.sections)}
//           storyHeadline={this.props.story.headline}
//         />

//         <SubscriptionComboBox
//           source="footer-Story Page"
//           variant="horizontal"
//           datalayerFields={datalayerFields}
//         />

//         <GetYourDailyBrief
//           variant="horizontal"
//           source="SB-Story Page"
//           datalayerFields={datalayerFields}
//         />

//         <div id="cx_bf408317f0c33e3364ff451f5103055d380fba1a" />
//       </React.Fragment>
//     );
//   }
// }

const SectionLink = ({
  section,
  storyHeadline,
  isGeoBlock,
  isLiveBlog,
  isSubscriber,
  isPremiumTemplate = false,
}) => {
  // device detection using plain JavaScript starts here
  // using this as react-device detect library is causing issues
  const [isMobile, setIsMobile] = useState(false);
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsMobile(width <= 768); // Defining mobile width breakpoint
      setIsDesktop(width > 768); // Defining NonMobile width breakpoint
    };

    // Initial check on component mount
    handleResize();

    // Listen for window resize events
    window.addEventListener('resize', handleResize);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  // device detection using plain JavaScript ends here

  // const sentence = getSectionSentence(section);
  const datalayerFields = {
    category: 'article page',
    action: storyHeadline,
    // label: sentence.anchorText,
    event: 'event articlepage',
    cd22: 'link',
    cd23: 'story footer',
    cd24: 'NA', // element id
    cd26: 'NA',
    cd31: 'Story',
    cd35: 'NA',
    cd34: 'NA', // source of the user
  };
  return (
    <div styleName="authoritative-section">
      <>
        {isDesktop && (
          <div className="responsive-ad content-center desktop-only">
            {isLiveBlog ? (
              <AdWithPlaceholder adtype="LiveBlogAfterLastParaDT" height="90px" width="728px" />
            ) : !isPremiumTemplate ? (
              <AdWithPlaceholder adtype="StoryFooterDT" height="90px" width="728px" />
            ) : null}
          </div>
        )}
        {isMobile && (
          <div className="responsive-ad content-center mobile-only">
            {isLiveBlog ? (
              <AdWithPlaceholder adtype="LiveBlogAfterLastParaMob" height="250px" width="300px" />
            ) : !isPremiumTemplate ? (
              <AdWithPlaceholder adtype="StoryFooterMob" height="250px" width="300px" />
            ) : null}
          </div>
        )}
      </>
      {!isGeoBlock && (
        <>
          {/* {`${sentence.start} `}
          <a
            href={`/${sentence.anchorLink}?src=read_more`}
            target="_blank"
            rel="noopener noreferrer"
            styleName="authoritative-section-link"
            onClick={() => trackUserInteraction(datalayerFields)}
          >
            {sentence.anchorText}
          </a>
          {` ${sentence.end}`} */}
          <div styleName="static-text">
            Get live{' '}
            <a
              href={`/markets?src=read_more`}
              target="_blank"
              rel="noopener noreferrer"
              styleName="authoritative-section-link"
              onClick={() => trackUserInteraction(datalayerFields)}
            >
              Stock market
            </a>{' '}
            updates,{' '}
            <a
              href={`/business?src=read_more`}
              target="_blank"
              rel="noopener noreferrer"
              styleName="authoritative-section-link"
              onClick={() => trackUserInteraction(datalayerFields)}
            >
              Business
            </a>{' '}
            news,{' '}
            <a
              href={`/the-latest?src=read_more`}
              target="_blank"
              rel="noopener noreferrer"
              styleName="authoritative-section-link"
              onClick={() => trackUserInteraction(datalayerFields)}
            >
              Today’s latest
            </a>{' '}
            news,{' '}
            <a
              href={`/trending?src=read_more`}
              target="_blank"
              rel="noopener noreferrer"
              styleName="authoritative-section-link"
              onClick={() => trackUserInteraction(datalayerFields)}
            >
              Trending
            </a>{' '}
            stories, and{' '}
            <a
              href={`/videos?src=read_more`}
              target="_blank"
              rel="noopener noreferrer"
              styleName="authoritative-section-link"
              onClick={() => trackUserInteraction(datalayerFields)}
            >
              Videos
            </a>{' '}
            on NDTV Profit.
            {/* {!isSubscriber && (
              <span>
                {' '}
                <a
                  href={`/bq-blue-subscription?src=read_more`}
                  target="_blank"
                  rel="noopener noreferrer"
                  styleName="authoritative-section-link"
                  onClick={() => trackUserInteraction(datalayerFields)}
                >
                  Subscribe
                </a>{' '}
                to get full access to Exclusives.
              </span>
            )} */}
          </div>
        </>
      )}
    </div>
  );
};

SectionLink.propTypes = {
  section: objectOf(any).isRequired,
  storyHeadline: string.isRequired,
  isGeoBlock: bool,
  isLiveBlog: bool,
  isSubscriber: bool,
  isPremiumTemplate: bool,
};

Footer.propTypes = {
  story: objectOf(any).isRequired,
  isGeoBlock: bool,
  isPremiumTemplate: bool,
  isSubscriber: bool,

  // PublisherAndSocialShareSection: func
};

const mapStateToProps = (state) => {
  return {
    isSubscriber: get(state, ['isSubscriber', 'isSubscriber'], false),
  };
};
export default connect(mapStateToProps, () => ({}))(Footer);
// export default Footer;
